type RoadmapsLocale = typeof import('../en/roadmaps').default

const roadmaps = {
	title: '{{collectionEntityLabelPlural}}',
	description:
		'Explora {{collectionEntityLabelPluralLower}} guiad{{collectionEntityGenderSuffixPlural}} para dominar nuevas habilidades',
	myRoadmaps: '{{collectionEntityLabelPlural}}',
	myRoadmapsDescription:
		'Sigue tu progreso en tus {{collectionEntityLabelPluralLower}}',
	noRoadmapsYet:
		'Aún no te has inscrito en ningún {{collectionEntityLabelLower}}',
	noRoadmaps: 'No hay {{collectionEntityLabelPluralLower}} disponibles',
	browseRoadmaps:
		'Explora {{collectionEntityLabelPluralLower}} disponibles para empezar',
	enroll: 'Inscribirse',
	enrolled: 'Inscrit{{collectionEntityGenderSuffix}}',
	progress: 'Progreso',
	completed: 'Completad{{collectionEntityGenderSuffix}}',
	inProgress: 'En progreso',
	listView: 'Lista',
	weekView: 'Semana',

	// Pace configuration
	configurePace: 'Configura tu ritmo',
	configurePaceDescription:
		'Elige cuánto tiempo quieres dedicar a "{{title}}" cada semana',
	weeklyMinutes: 'Tiempo de estudio semanal',
	sessionsPerWeek: 'Sesiones por semana',
	week: 'semana',
	paceSummary: '~{{minutes}} minutos por sesión, {{sessions}} veces por semana',

	// Weekly plan
	weeklyPlan: 'Plan semanal',
	weeklyPlanSummary: '{{minutes}} minutos en {{sessions}} sesiones esta semana',
	noWeeklyPlan: 'Inscríbete para ver tu plan de estudio semanal',
	noSessionPlanned: 'Día de descanso',
	currentlyStudying: 'Estudiando actualmente',
	upNext: 'Siguiente',

	// Next up
	nextUp: 'Continuar',
	nextUpNotStarted: 'Listo para empezar',
	nextUpInProgress: 'Retoma donde lo dejaste',
	nextUpNextInSequence: 'Siguiente en la secuencia',

	// Course actions
	startCourse: 'Empezar',
	continue: 'Continuar',
	review: 'Revisar',
} satisfies RoadmapsLocale

export default roadmaps
